import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import './layout.css';
import footerLogo from '../../template/images/LHubFooter.png';
import { useForm } from 'react-hook-form';
import validationRules from '../../util/validationRules/ValidationRules';
import ReCAPTCHA from 'react-google-recaptcha';
import { post } from '../../util/axiosConfig/AxiosConfig'
import axios from "axios";
import showAlert from "../alert/Alert";



const Footer = () => {
    const { register, handleSubmit, formState: { errors }, reset,setError } = useForm();
    const [captchaValue, setCaptchaValue] = useState(null);
    const [captchaError, setCaptchaError] = useState('')
    const currentYear = new Date().getFullYear();
    const [loading, setLoading] = useState(false);

    const recaptchaRef = useRef(null);
    const navigate = useNavigate();

    const activityCallback = () => {
        navigate('/')
    }

    const onSubmit = async (data) => {
        const Data = {
            id: 0,
            email: data.email,
            optForNewsLetter: true,
            name: data.name
        }

        const captchaValid = await verifyCaptcha(captchaValue);
        if (captchaValid) {
            setCaptchaError(false)

            console.log('FormData', data);

            recaptchaRef.current.reset();
            setCaptchaValue(null);
            reset();
            const sendData = async () => {
                try {
                    setLoading(true);
                    const response = await post('admin/api/v1/lms-admin/subscription/create', Data);
                    setLoading(false);
                    if (response.message == 'Created') {
                        showAlert('Great!', ' Subscription details has been submitted.', 'success', 'OK', false, false, activityCallback, false, 'Cancel', '');
                    } else {
                        showAlert('Abort!', `Unable to submit subscription form data`, 'error', 'Ok', false, false, '', false, '', '');
                    }

                } catch (error) {
                    showAlert('Abort!', ' Unable to submit subscription form data', 'error', 'Ok', false, false, '', false, '', '');
                    setLoading(false);
                    setError(error.response.data)
                } finally {
                    setLoading(false);
                }
            };
            sendData();
        } else {
            setCaptchaError(true);
        }
    }

    const handleCaptchaChange = (value) => {
        setCaptchaValue(value);
        if (value) {
            setCaptchaError(false);
        }
    };

    // Google reCAPTCHA V2
    const verifyCaptcha = async (captchaValue) => {
        if (!captchaValue) return false;
        // const secretKey = '6LfTUzYqAAAAAKgJisqWkfOC5pEktWqq77w5ivfq';
        let captchaValueObj = {
            "captchaValue": captchaValue
        }

        try {
            const response = await post(`web/api/v1/lms-web/open/verify`, captchaValueObj);
            if (response.success == true) {
                return response.success;
            } else {
                console.error('CAPTCHA verification failed:', response.success);
                return false;
            }
        } catch (error) {
            console.error('Error verifying CAPTCHA:', error);
            return false;
        }
    };

    const redirectToOutPage = (path) => {
        if (path == 'refuntPolicy') {
            navigate('./RefundPolicy','_blank')
        } else if (path == 'privacyPolicy') {
            window.open('https://finlabsindia.org/privacy-policy/', '_blank');
        }  else if (path == 'contactUs') {
            window.open('https://finlabsindia.org/contact-us/', '_blank');
        } else {
            window.open('https://finlabsindia.org/terms-conditions/', '_blank');
        }
    }

    const redirectToCourse = () => {
        showAlert(' ','Please choose a course before proceeding to sign up.', ' ', 'Continue', false, false, redirectTo, false, '', '');
    }

    const redirectTo = (value) => {
        navigate('/')
     }

    return (
        <React.Fragment>
            <div className="footer_upper">
                <div className="container">
                    <img src={footerLogo} alt="Brand Logo" className="img-fluid footer_brand_logo" />
                </div>
            </div>
            <div className="footer_outer">
                <div className="container">
                    <div className="footer_inner">
                        <div className="row">
                            <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12">
                                <div className="footer_nav">
                                    <ul className="nav_ul">
                                        <li className="nav_li home">
                                            <Link to="/"><p>Home</p></Link>
                                        </li>
                                        <li className="nav_li signUp">
                                            {/* <Link to="/createAccount"><p>Sign Up</p></Link> */}
                                            <p className="" onClick={()=>redirectToCourse()}>Sign Up</p>
                                        </li>
                                        <li className="nav_li" onClick={() => redirectToOutPage('refuntPolicy')}>
                                            <p>Refund Policy</p>
                                        </li>
                                        <li className="nav_li" onClick={() => redirectToOutPage('privacyPolicy')}>
                                            <p>Privacy Policy</p>
                                        </li>
                                        <li className="nav_li" onClick={() => redirectToOutPage('termsAndCondition')}>
                                            <p>Terms and Conditions</p>
                                        </li>
                                        <li className="nav_li" onClick={() => redirectToOutPage('contactUs')}>
                                            <p>Contact Us</p>
                                        </li>
                                    </ul>

                                    <div className="corporateAddress">
                                        <p className="c_address_title">Corporate Address : </p>
                                        <p className="c_name add">Finlabs India Private Limited</p>
                                        <p className="c_address add">Wework, G Block BKC, Bandra Kurla Complex, Bandra East, Mumbai, Maharashtra 400051</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12" id = "info">
                                <div className="subscribe_form">
                                    <p className="sub_form_text"><i>Subscribe to receive updates from us. You can unsubscribe any time.</i></p>
                                    <form onSubmit={handleSubmit(onSubmit)}>
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="mb-2">
                                                    {/* <label htmlFor="idName" className="form-label">Name</label> */}
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="idName"
                                                        aria-describedby="idName"
                                                        placeholder="Name"
                                                        autoComplete="off"
                                                        name="firstName"
                                                        {...register('name', {
                                                            required: { value: true, message: 'Field cannot be left blank' },
                                                            pattern: {
                                                                value: /^[A-Za-z]+(?: [A-Za-z]+)*$/,
                                                                message: 'Name should only contain letters.',
                                                            },
                                                        })}
                                                    />

                                                    {errors.name && (
                                                        <p className="error-message text-danger">{errors.name.message}</p>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <div className="mb-2">
                                                    {/* <label htmlFor="idEmailID" className="form-label">Email ID</label> */}
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="idEmailID"
                                                        aria-describedby="idEmailID"
                                                        placeholder="Email"
                                                        autoComplete="off"
                                                        name="email"
                                                        {...register('email', {
                                                            required: { value: validationRules.email.required, message: validationRules.email.requiredMsg },
                                                            pattern: {
                                                                value: /^(?!.*\.\.)(?!.*\.$)(?!.*\.\@)[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/,
                                                                message: 'Invalid email',
                                                            },
                                                        })}
                                                    />

                                                    {errors.email && (
                                                        <p className="error-message text-danger">{errors.email.message}</p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Google reCAPTCHA V2*/}
                                                <div className="captchaMain">
                                                <ReCAPTCHA
                                            ref={recaptchaRef}
                                            sitekey="6LfTUzYqAAAAAGkEwNNkuGZwyXHxB6HuOBv5cDjL"
                                            onChange={handleCaptchaChange}
                                        />
                                        {captchaError && <p className="captcha_error mt-1 text-danger">Please complete the CAPTCHA</p>}
                                                </div>
                                        
                                        <div className="subscribe_form_sub_btn_main">
                                            <button type="submit" className="subscrib_newsltr_btn" >Subscribe</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="footer_lower1"></div>
                <div className="footer_lower2"></div>
            </div>
            <div className="footer_lower">
                <div className="container">
                    <p className="copyright_text">&copy; copyright {currentYear} Finlabs India Pvt. Ltd. | All Rights Reserved.</p>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Footer;